import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Pipe, PipeTransform } from '@angular/core';

export class ProtocoloConsultaImpedimentoArquivo extends BaseEntity {
    public id: number;
    public TipoConsultaProtocolo: string;
    public statusConsultaProtocolo: string;
    public dataEnvio: Date;
    public usuarioEnvio: string;
    public origemProtocolo: string;
    public tamanhoConteudoEnvio: number;
    public tamanhoConteudoResposta: number;
    public nomeAgente: string;

}

export enum StatusConsultaProtocolo {
    ERROS_ENCONTRADOS_VALIDACAO_ARQUIVO = 'EV',
    AGUARDANDO_VALIDACAO = 'A',
    PROCESSADO = 'p',
    ERRO_PROCESSAMENTO = 'EP',
    CANCELADO = 'C'
  }

  export const STATUS_CONSULTA_PROTOCOLO = [
  {
    codigo: 'A',
    label: 'Aguardando validação'
  },
   {
    codigo: 'EV',
    label: 'Erros encontrados na validação do arquivo'
  },
  {
    codigo: 'S',
    label: 'Processado com sucesso'
  },
     {
    codigo: 'P',
    label: 'Processando'
  },
  {
    codigo: 'EP',
    label: 'Erro no processamento'
  }
];


export const TIPO_PROTOCOLO_CONSULTA_IMPEDIMENTO = [
  {
    codigo: '1',
    descricao: 'Importacao certidão CADIN'
  }

];
